/**
 * @file Grid atom — responsive column-grid compound family.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/Grid
 */
export { Grid, GridItem } from "@/components/ui/grid";
